module.exports = __webpack_public_path__ + "img/ATRC Platform - Cookie Policy-1.ae9ef817.png";